module.exports = __webpack_public_path__ + "tc.svg?b4bb9eb97bc9a08134d10995b78f9d67";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/tc.svg
// module id = 1389
// module chunks = 27